import Chart from "chart.js/auto";

export const generateChartImage = ({data, width = 630, height = 250}) => {
  const newCanvas = document.createElement("canvas");
  newCanvas.setAttribute("id", "tempCanvas");
  document.body.appendChild(newCanvas);
  document.getElementById("tempCanvas").style.maxWidth = width + "px";
  document.getElementById("tempCanvas").style.maxHeight = height + "px";
  document.getElementById("tempCanvas").style.display = "none";

  const ctx = newCanvas.getContext("2d");
  ctx.canvas.width = 630;
  ctx.canvas.height = 250;
  let stringArray = [];
  const personalValues = [];

  stringArray = data.personalCurve.split(",");
  for (let x = 0; x < stringArray.length; x++) {
    personalValues.push(stringArray[x]);
  }

  const chartLength = personalValues.length;
  const lengthArray = [];
  const dayOneArray = [];
  const dayTwoArray = [];

  const highValues = [];
  stringArray = data.topCurve.split(",");
  for (let x = 0; x < stringArray.length; x++) {
    highValues.push(stringArray[x]);
  }

  const lowValues = [];
  stringArray = data.bottomCurve.split(",");
  for (let x = 0; x < stringArray.length; x++) {
    lowValues.push(stringArray[x]);
  }

  const averageValues = [];
  stringArray = data.meanCurve.split(",");
  for (let x = 0; x < stringArray.length; x++) {
    averageValues.push(stringArray[x]);
  }

  for (let i = 0; i < chartLength; i += 1) {
    if (i == 0 || !(i % 7) || i == chartLength) {
      lengthArray.push("" + i + "");
    } else {
      lengthArray.push("");
    }

    if (i == 13) {
      dayOneArray.push(1.67);
    } else {
      dayOneArray.push(null);
    }

    if (i == 22) {
      dayTwoArray.push(21);
    } else {
      dayTwoArray.push(null);
    }
  }

  const newChart = new Chart(ctx, {
    type: "line",
    data: {
      labels: lengthArray,
      datasets: [
        {
          label: "Average",
          data: averageValues,
          fill: false,
          backgroundColor: "#f9c19b",
          borderColor: "#f9c19b",
          borderWidth: 1,
        },
        {
          label: "Low",
          backgroundColor: "#EF94DD",
          borderColor: "#EF94DD",
          fill: false,
          borderDash: [5, 5],
          data: lowValues,
          borderWidth: 1,
        },
        {
          label: "High",
          backgroundColor: "#5BC5F2",
          borderColor: "#5BC5F2",
          fill: false,
          borderDash: [5, 5],
          data: highValues,
          borderWidth: 1,
        },
        {
          label: "Personal Curve",
          data: personalValues,
          fill: false,
          borderWidth: 7,
          pointBorderWidth: 1,
          borderColor: "#d8edef",
          backgroundColor: "#d8edef",
        },
      ],
    },
    options: {
      responsive: true,
      animation: false,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
      },
      elements: {
        point: {
          radius: 0,
        },
      },
      tension: 0.3,
      scales: {
        x: {
          display: true,
          backgroundColor: "#FFFFFF",
          title: {
            display: true,
            text: "DAY",
            font: {
              size: 10,
            },
            color: "#b3b3b3",
          },
          legend: {
            display: false,
          },
          grid: {
            display: false,
            borderColor: "#b3b3b3",
            drawBorder: true,
            drawTicks: true,
            tickColor: "#b3b3b3",
            z: 9999,
          },
          ticks: {
            autoSkip: false,
            maxRotation: 0,
            minRotation: 0,
            min: 0,
            max: 31,
            stepSize: 7,
            z: 99999,
          },
        },
        y: {
          display: true,
          backgroundColor: "#FFFFFF",
          title: {
            display: true,
            text: data.measurement,
            font: {
              size: 10,
            },
            color: "#b3b3b3",
          },
          legend: {
            display: false,
          },
          grid: {
            display: false,
            borderColor: "#b3b3b3",
            drawBorder: true,
            drawTicks: true,
            tickColor: "#b3b3b3",
            z: 9999,
          },
          ticks: {
            scaleBeginAtZero: false,
            beginAtZero: false,
            min: 0,
            suggestedMin: 0,
            autoSkip: false,
            maxRotation: 0,
            minRotation: 0,
            z: 99999,
          },
        },
      },
    },
  });

  const url = newChart.toBase64Image();
  newCanvas.remove();

  return url;
};
